export default {
    'package_version': '2.0.61008.4'
  };
